import Link from "@casino/client/components/Link";
import type { GamePageTranslations } from "@casino/server/graphql/getCmsGamePagePhrases";
import translatePhrase from "@casino/ui/Games/translatePhrase";
import { Button, InfoIcon } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  shortUrl?: string;
  translations?: GamePageTranslations;
};

const CLASSES =
  "text-white! bg-white/10! hover:bg-white/20! backdrop-blur-lg rounded-lg size-8";

const TournamentReadMoreButton: FC<Props> = ({ shortUrl, translations }) => {
  const label = translatePhrase(
    translations,
    "game.tournament.readmore",
    "Read More",
  );

  if (!shortUrl) {
    return (
      <Button
        data-testid="tournament-read-more"
        variant="ghost"
        disabled
        className={CLASSES}
      >
        <InfoIcon />
        <span className="sr-only">{label}</span>
      </Button>
    );
  }

  return (
    <Button
      asChild
      data-testid="tournament-read-more"
      variant="ghost"
      className={CLASSES}
    >
      <Link href={`/tournaments/${shortUrl}`}>
        <InfoIcon />
        <span className="sr-only">{label}</span>
      </Link>
    </Button>
  );
};

export default TournamentReadMoreButton;
